module.exports = __webpack_public_path__ + "img/NG.ffd18fe3.svg";